import { render, staticRenderFns } from "./AuditTrailDetail.vue?vue&type=template&id=65b58fc6"
import script from "./AuditTrailDetail.vue?vue&type=script&lang=js"
export * from "./AuditTrailDetail.vue?vue&type=script&lang=js"
import style0 from "./AuditTrailDetail.vue?vue&type=style&index=0&id=65b58fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports